import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replace'
})
export class ReplacePipe implements PipeTransform {

    transform(value: string): any {
        if (value.indexOf('\\') > -1) {

            return value.split('\\').pop();
        }
        if (value.indexOf('/') > -1) {
            return value.split('/').pop();
        }
        return value;
    }
}
